import { GetClientResponseDto } from '~/store/apis/dtos/clients/clients.dto';
import { ClientBase } from '~/models/clients/clientBase';
import { ContractStatus, CountryCode } from '~/enums';
import { Language } from '~/store/types/sharedTypes';
import { formatPersonalNumber } from '~/helpers/formatters.helper';
import { Company } from '~/models/clients/company';

const filterCompanies = ({ client: { companies } }: GetClientResponseDto) => {
  const set = new Set();

  const hasDuplicateCompanies = companies
    .sort((a) =>
      [
        ContractStatus.OpenActive,
        ContractStatus.OpenLate,
        ContractStatus.OpenInCollection,
      ].includes(a.status)
        ? -1
        : 1
    )
    .some((c) => set.size === set.add(c.company_no).size);

  if (hasDuplicateCompanies) {
    const duplicatedCompanies = companies?.filter(
      (value, index, self) =>
        self.findIndex((cc) => cc.company_no === value.company_no) !== index
    );

    return companies?.filter((c) => !duplicatedCompanies.includes(c));
  }

  return companies;
};

export const mapGetClient = (response: GetClientResponseDto): ClientBase => {
  const activeCompanyIdFromLocalStorage = localStorage.getItem(
    '@qred/activeCompanyId'
  );
  const mappedCompanies = filterCompanies(response).map((company) => ({
    city: company.company_city,
    companyNumber: company.company_no,
    companyName: company.company_name,
    id: company.company_id,
    phone: company.company_phone,
    street: company.company_street,
    zip: company.company_zip,
    hasActiveLoans:
      company.loan_id !== null &&
      ['Open_Active', 'Open_Late', 'Open_In_Collection'].includes(
        company.status
      ),
  })) as Company[];

  const defaultCompany = mappedCompanies[0];

  return {
    id: response.client.user_id,
    personalNumber: formatPersonalNumber(
      response.client.personal_no,
      response.client.info.country as CountryCode
    ),
    country: response.client.info.country as CountryCode,
    language: response.client.info.language as Language,
    info: {
      firstName: response.client.info.first_name,
      lastName: response.client.info.last_name,
      city: response.client.info.city,

      email: response.client.info.email,
      gender: response.client.info.gender,

      phone: response.client.info.phone,
      street: response.client.info.street,
      zip: response.client.info.zip,
    },
    companies: mappedCompanies,
    activeCompany:
      activeCompanyIdFromLocalStorage !== null
        ? mappedCompanies.find(
            (company) => company.id === Number(activeCompanyIdFromLocalStorage)
          ) ?? defaultCompany
        : defaultCompany,
  };
};
